module.exports = __webpack_public_path__ + "static/newcastle-station-07c3816882c478538d81eb113b514988.jpg";